////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { isNull, isUndefined } from 'lodash'
///////COMPONENTS///////
import Tooltip from '../../../components/Tooltip/Tooltip'
import theme from '../../../theme/theme'

//////STYLED//////
const KioskProductionListStatusWrapper = styled.div`
	cursor: ${(props) => (!isUndefined(props.handleClick) && !isNull(props.handleClick) ? 'pointer' : 'inherit')};
`
const KioskProductionListStatusColor = styled.div`
	width: 20px;
	height: 20px;
	background-color: ${(props) => {
		switch (props.level) {
			case 1:
				return theme.colors.validation

			case 2:
				return theme.colors.warning

			case 3:
				return theme.colors.error

			default:
				return theme.colors.cancel
		}
	}};
	border-radius: 10px;
	margin: auto;
`
//////STYLED//////

const KioskProductionListStatus = (props) => {
	let level = props.rowTableSkeleton ? 0 : props.level

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<KioskProductionListStatusWrapper handleClick={props.handleClick}>
			{!isUndefined(props.tooltip) ? (
				<Tooltip translationsKey={props.tooltip} tooltipId={`kioskProductionList_${props.tooltipId}`}>
					<KioskProductionListStatusColor level={level} onClick={() => !isUndefined(props.handleClick) && props.handleClick()} />
				</Tooltip>
			) : (
				<KioskProductionListStatusColor level={level} onClick={() => !isNull(props.handleClick) && props.handleClick()} />
			)}
		</KioskProductionListStatusWrapper>
	)
}

KioskProductionListStatus.propTypes = {}

KioskProductionListStatus.defaultPropTypes = {}

export default KioskProductionListStatus
